import { Box, Grid, GridItem, Icon, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { LuCopyright } from 'react-icons/lu';
import backgroundImage from '../assets/BackgroundSpark.svg';
import { scrollbarStyles } from './Constants';

const Layout = ({
  header: Header,
  body: Body,
  footer: Footer,
  gridHeaderRegionHeight,
  gridMainRegionHeight,
  gridFooterRegionHeight,
  hasGenericFooter,
  showBackgroundImage,
  ...props
}) => {
  const [templateAreas, setTemplateAreas] = useState('main');
  const [gridTemplateRows, setGridTemplateRows] = useState('1fr');

  useEffect(() => {
    if (Header && Body && (Footer || hasGenericFooter)) {
      setTemplateAreas(`
        "header"
        "main"
        "footer"
      `);

      setGridTemplateRows(
        `${gridHeaderRegionHeight || '200px'} ${
          gridMainRegionHeight || '1fr'
        } ${gridFooterRegionHeight || '70px'}`
      );

      // setGridTemplateRows('200px 1fr 90px');
    } else if (Header && Body) {
      setTemplateAreas(`
        "header"
        "main"
      `);

      setGridTemplateRows(
        `${gridHeaderRegionHeight || '200px'} ${gridMainRegionHeight || '1fr'}`
      );

      // setGridTemplateRows('200px 1fr');
    } else if (Body && (Footer || hasGenericFooter)) {
      setTemplateAreas(`
        "main"
        "footer"
      `);

      setGridTemplateRows(
        `${gridMainRegionHeight || '1fr'} ${gridFooterRegionHeight || '90px'}`
      );
      // setGridTemplateRows('1fr 90px');
    } else if (Header && (Footer || hasGenericFooter)) {
      setTemplateAreas(`
        "header"
        "footer"
      `);

      setGridTemplateRows(
        `${gridHeaderRegionHeight || '200px'} ${
          gridFooterRegionHeight || '70px'
        }`
      );

      // setGridTemplateRows('200px 90px');
    } else if (Header) {
      setTemplateAreas(`
        "header"
      `);
      setGridTemplateRows(`${gridHeaderRegionHeight || '200px'}`);
      // setGridTemplateRows('200px');
    } else if (Body) {
      setTemplateAreas(`
        "main"
      `);
      setGridTemplateRows(`${gridMainRegionHeight || '1fr'}`);
      // setGridTemplateRows('1fr');
    } else if (Footer || hasGenericFooter) {
      setTemplateAreas(`
        "footer"
      `);
      setGridTemplateRows(`${gridFooterRegionHeight || '70px'}`);
      // setGridTemplateRows('90px');
    }
  }, [
    Body,
    Footer,
    Header,
    gridFooterRegionHeight,
    gridHeaderRegionHeight,
    gridMainRegionHeight,
    hasGenericFooter,
  ]);

  return (
    <Grid
      style={{ ...props }}
      // templateAreas={`"header"
      //           "main"
      //           "footer"`}
      // gridTemplateRows={'200px 1fr 90px'}
      templateAreas={templateAreas}
      gridTemplateRows={gridTemplateRows}
      gridTemplateColumns={'1fr'}
      h="100vh"
      gap="1"
      color="blackAlpha.700"
      fontWeight="bold"
    >
      {Header && (
        <GridItem
          gridArea="header"
          bg="white"
          color="black"
          pt="50px"
          ml={{ base: '0px', md: '1.7rem' }}
        >
          <Header />
        </GridItem>
      )}
      {/* <GridItem gridArea="header" bg="white" color="black" pt="50px">
        <Header />
      </GridItem> */}
      <GridItem
        gridArea="main"
        bg="white"
        overflowY="auto"
        overflowX="hidden"
        backgroundImage={showBackgroundImage && `url(${backgroundImage})`}
        backgroundRepeat={'no-repeat'}
        backgroundPosition={'center'}
        sx={scrollbarStyles}
      >
        <Body />
      </GridItem>
      <GridItem
        gridArea="footer"
        bg="white"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        {Footer && <Footer />}
        {hasGenericFooter && (
          <Box>
            <Text
              display="flex"
              alignItems="center"
              textAlign="center"
              justifyContent="center"
              color="#718096"
              fontWeight="500"
              fontSize="0.95rem"
            >
              © 2024 Studywise. All Rights Reserved.
            </Text>
          </Box>
        )}
      </GridItem>
    </Grid>
  );
};

export default Layout;
